//
//
//
//
//
//

import Cookies from "js-cookie";
import API from "@/api";

export default {
  name: "Load",
  created() {
    this.parseTokenFromQuery();
  },
  methods: {
    async parseTokenFromQuery() {
      try {
        // 获取 URL 中的 query 参数
        const queryData = this.$route.query.data;

        if (!queryData) {
          console.log("未找到 data 参数");
          return;
        }

        // 解析 data JSON 字符串
        const dataObj = JSON.parse(queryData);

        // 获取 token 数组
        const tokens = dataObj.token;

        if (!tokens || !Array.isArray(tokens)) {
          console.log("token 数据格式不正确");
          return;
        }

        // 遍历 token 数组 写入cookie
        tokens.forEach((token, index) => {
          Cookies.set(token.key, token.value);
        });

        // 也可以打印完整的 token 数组
        console.log("完整 Token 数组:", tokens);

        // 调用 loginAfter 接口
        await this.callLoginAfter();
      } catch (error) {
        console.error("解析 token 数据出错:", error);
      }
    },
    async callLoginAfter() {
      const res = await API.vega.user.loginAfter({
        gt: encodeURIComponent(Cookies.get("GT")),
      });
      if (res && res.data && res.data.sub_code === 0) {
        const userInfo = res.data.data;
        Cookies.set("_USER_INFO", JSON.stringify(userInfo));
        this.$store.commit("updateLogin", { isLogin: true });
        this.$store.commit("updateUserInfo", userInfo);
        this.$store.commit("updateCompanyStatus", userInfo.companyStatus);
      }
      // 接口出任何问题都要跳转到我的页面
      this.$router.replace("/mine/index");
    },
  },
};
